module.exports = __webpack_public_path__ + "static/media/YM62_1.83eb50d2.jpg";